/* eslint-disable-next-line import/prefer-default-export */
export const getCurrentStoryPrompt = state => state.storyPrompts.current
export const getStoryPromptEnabled = state => state.storyPrompts.isEnabled
